import { GenericErrorBoundary } from "./GenericErrorBoundary";
import { BaseErrorBoundaryProps, FormContext, createFormState } from "./types";

interface Props extends BaseErrorBoundaryProps, FormContext {}

export function AssistantMultiStepFormStepErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="AssistantMultiStepFormStep"
      errorBoundaryName="AssistantMultiStepFormStepErrorBoundary"
      componentType="AssistantFormStep"
      title="Assistant Form Step Error"
      description="The assistant form step encountered an error. Please reload the page to continue with your assistant process."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createFormState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
